// extracted by mini-css-extract-plugin
module.exports = {"content":"about-layout_content__Mvn7w"};